import css from '../app-header.module.scss'

const UserMenuLineSeparator = () => <div className={css.horizontalSeparator} />

export default UserMenuLineSeparator
